module.exports = {"id":"216334","name":"Pieter Gerkens","rating":"73","photo":"./data/images/photos/0/216334.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["MOC","MC","ATT","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PieterGerkens0.json
// module id = 3467
// module chunks = 0